/**
 * 权限字典
 */
export enum AuthDictionary {
  /**
   * 超级管理员
   */
  manager = 'manager',
  /**
   * 编辑商品
   */
  updateGood = 'updateGood',
  /**
   * 编辑商户信息
   */
  updateStoreInfo = 'updateStoreInfo',
  /**
   * 商品上架/下架
   */
  goodUpOrDown = 'goodUpOrDown',
  /**
   * 编辑打印机
   */
  updatePrinter = 'updatePrinter',
  /**
   * 编辑基础数据
   */
  updateBaseInfo = 'updateBaseInfo',
  /**
   * 编辑餐台
   */
  updateDesk = 'updateDesk',
  /**
   * 编辑员工
   */
  updateStaff = 'updateStaff',
  /**
   * 系统日志
   */
  logger = 'logger',
}

export default [
  {
    code: AuthDictionary.manager,
    name: '超级管理员'
  },
  {
    code: AuthDictionary.updateGood,
    name: '编辑商品'
  },
  {
    code: AuthDictionary.updateStoreInfo,
    name: '编辑商户信息'
  },
  {
    code: AuthDictionary.goodUpOrDown,
    name: '商品上架/下架'
  },
  {
    code: AuthDictionary.updatePrinter,
    name: '编辑打印机',
  },
  {
    code: AuthDictionary.updateBaseInfo,
    name: '编辑基础数据'
  },
  {
    code: AuthDictionary.updateDesk,
    name: '编辑餐台'
  },
  {
    code: AuthDictionary.updateStaff,
    name: '编辑员工'
  },
  {
    code: AuthDictionary.logger,
    name: '系统日志'
  }
]